window.onload = function () {
	// News Ticker
		swiper = new Swiper(".swiper", {
			slidesPerView: 1.2,
			spaceBetween: 0,
			speed: 500,
			navigation: {
				nextEl: ".step-item-next",
				prevEl: ".step-item-prev",
			},
			breakpoints: {
				767: {
					slidesPerView: 2.1,
					spaceBetween: 10,
				},
				1024: {
					slidesPerView: 2.5,
					spaceBetween: 10,
				},
				1280: {
					slidesPerView: 3.5,
					spaceBetween: 10,
				}
			},
		});
};
